import React from 'react';
import MarkdownPage from '../Components/InfoPages/MarkdownPage';

function AboutPage() {
  return <MarkdownPage slug="about" titleKey="infoPages.aboutCxb.title" descriptionKey="infoPages.aboutCxb.description" />;
}

export default AboutPage;
